import { render, staticRenderFns } from "./addSpike.vue?vue&type=template&id=bbffc274&scoped=true"
import script from "./addSpike.vue?vue&type=script&lang=js"
export * from "./addSpike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbffc274",
  null
  
)

export default component.exports